import React from 'react'
import { CGE } from '../../../../common/components/CGE';
import { decode_utf8, transformId, beforeMaskedValueChangeRut, isRutValid} from '../../../../common/utils/utilsFunc';
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function VulnerableAgreementFormEdit({props}) {
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [values, setValues] = React.useState({})
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    React.useEffect(() => {
        if(props.state?.modificationFormCovidDataResponse) {
            props.setLoading(false)
            if(props.state?.modificationFormCovidDataResponse?.code !== 0) {
                props.setGlobalAlert(props.state?.modificationFormCovidDataResponse?.message, "warning", true, "Advertencia");
            } else {
                props.setGlobalAlert(props.state?.modificationFormCovidDataResponse?.message, "success", true, "Confirmación");
            }
        }
    }, [props.state?.modificationFormCovidDataResponse]);
    
    React.useEffect(() => {
        if(props.state?.checkModificationFormCovidResponse) {
            props.setLoading(false)
            if(props.state?.checkModificationFormCovidResponse?.code !== 0) {
                props.setGlobalAlert(props.state?.checkModificationFormCovidResponse?.message, "warning", true, "Advertencia");
                setValues({ ...values, qtdCuetas: 12 })
            } else {
                setValues({ ...values, qtdCuetas: props.state?.checkModificationFormCovidResponse?.numCuotas })
            }
        }
    }, [props.state?.checkModificationFormCovidResponse]);

    function checkModifFormCovidHandler() {
        if (transformId(props.state.idClientAux) !== transformId(values.idClient) || !values.idClient) {
            props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.", "warning");
        } else if(!values.rut || (values.rut && values.rut.length !== 12)) {
            props.setGlobalAlert("Debes ingresar un RUT válido.", "warning");
        } else if(values.idClient && values.rut && values.rut.length === 12) {
            props.setCheckModifFormCovid({ cta_cto: values.idClient, rut: values.rut })
        }
    }

    let propsLabelInfoContent = {
        "content": props.state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }
    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleClickButtonClient() {
        if (values.idClient) {
            props.setIdClient(values.idClient);
        } else {
            setInputValidate({ ...inputValidate, ...inputValidate.empty.idClient = true, ...inputValidate.msg.idClient = "Debe ingresar un Nro de Cliente" })
            props.setGlobalAlert(`Complete todos los campos obligatorios.`,"warning");
        }
    }

    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.idClient) {
            errors.empty.idClient = false;
        } else {
            errors.empty.idClient = true;
            errors.msg.idClient = "Debe ingresar un Nro de Cliente"
        }

        if (values.rut) {
            errors.empty.rut = false;
            if (!isRutValid(values.rut)) {
                    errors.validated.rut = true;
                    errors.msg.rut = "Debes ingresar un RUT válido."
                } else{
                    errors.validated.rut = false;
                }
        } else {
            errors.empty.rut = true;
            errors.msg.rut = "Debes ingresar el RUT del solicitante."
        }

        if (values.qtdCuetas) {
            errors.empty.qtdCuetas = false;
        } else {
            errors.empty.qtdCuetas = true;
            errors.msg.qtdCuetas = "Debes selecionar una opción"
        }

        setInputValidate(errors)
        return errors
    }

    function handleSubmit() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        } else if (transformId(props.state.idClientAux) !== transformId(values.idClient)) {
            props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.", "warning");
        } else if (!props.state?.checkModificationFormCovidResponse) {
            props.setGlobalAlert("Debes realizar la verificación del RUT.", "warning");
        } else if (props.state?.checkModificationFormCovidResponse?.numCuotas === values.qtdCuetas) {
            props.setGlobalAlert("Si desea modificar la cantidad de cuotas, por favor seleccione un valor distinto.", "warning");
        } else {
            props.setModificationFormCovidData({ cta_cto: values.idClient, nroCuotas: values.qtdCuetas, rut: values.rut })
        }
    }

  return (
    <div id="vulnerableAgreementFormEdit">
        <CGE.Panel title={decode_utf8(props.title_2_vulnereble_agreement)} >
            <CGE.PanelSection title={decode_utf8(props.title_section_client)} >
                <div class="row">
                    <div className="col-md-12">
                        <CGE.DetailClient
                            props={{
                                handleChange: (e) => setValues({ ...values, idClient: e.target.value }),
                                hasError: inputValidate?.empty?.idClient,
                                msgError: inputValidate?.msg?.idClient,
                                idClient: values.idClient,
                                idFormElement: "numberClientId",
                                labelName: "N° Cliente:",
                                placeholder: "Número de Cliente",
                                mandatoryElement: true,
                                valuePub: values.idClient,
                                labelButton: "Buscar",
                                handleClick: () => { handleClickButtonClient() },
                                sizeButton: "sm",
                                typeButton: "primary",
                                propsLabelInfoContent:propsLabelInfoContent
                            }}
                            propsDetail={{
                                fullNameClient: (props.detailClientJson?.PRIMER_NOMBRE_PERSONA || props.detailClientJson?.SEGUNDO_NOMBRE_PERSONA
                                    || props.detailClientJson?.APELLIDO_PERSONA) ? values.socialReason = `${props.detailClientJson?.PRIMER_NOMBRE_PERSONA} 
                                    ${props.detailClientJson?.SEGUNDO_NOMBRE_PERSONA} ${props.detailClientJson?.APELLIDO_PERSONA}` : "",
                                comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                                calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                                nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                                dptoBlockClient: (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO) ? `${props.detailClientJson?.SUPLEMENTO} 
                                ${props.detailClientJson?.PISO}` : "",
                                ctaCtoClient: props.detailClientJson?.CTA_CTO
                            }}
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.title_section_solicitante_convenio_vulnerable)}>
                <div className="row">
                    <div className="col-md-8">
                        <div className="d-flex">
                            <div className="col-md-9 pl-0 pr-0">
                                <CGE.FormsField
                                    handleChange={(e) => setValues({ ...values, rut: e.target.value })}
                                    idFormElement="rut"
                                    mandatoryElement={true}
                                    labelName="RUT/N° de Carnet de identidad"
                                    placeholder="Rut(Ej: 12345678-9)"
                                    hasError={inputValidate?.empty?.rut || inputValidate?.validated?.rut}
                                    msgError={inputValidate?.msg?.rut}
                                    value={values.rut}
                                    typeElement="input-mask"
                                    maxLength="12"
                                    beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                    formatChars={{
                                        9: "[0-9]",
                                        k: "[Kk0-9]",
                                    }}
                                    mask="9.999.999-kk"
                                    maskChar={null}
                                />
                            </div>
                            <div className="col-md-3">
                                <CGE.Spacing type="gn" />
                                <CGE.Button
                                    label="Verificar"
                                    size="sm"
                                    onClick={() => checkModifFormCovidHandler()}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, dateConsult: e.target.value })}
                            idFormElement="dateConsult"
                            disabled={true}
                            typeElement="input"
                            labelName="Fecha de la consulta"
                            placeholder="Fecha de la consulta"
                            maxLength="10"
                            hasError={inputValidate?.empty?.dateConsult}
                            msgError={inputValidate?.msg?.dateConsult}
                            value={props.state?.checkModificationFormCovidResponse?.fecha}
                        />
                    </div>
                </div>
            </CGE.PanelSection>
            <CGE.PanelSection title={decode_utf8(props.title_section_vulnerabilidad_convenio_vulnerable)} >
                <div className="row">
                <div className="col-md-12">
                        <CGE.FormsField
                            handleChange={(e) => setValues({ ...values, qtdCuetas: e.target.value })}
                            idFormElement="qtdCuetas"
                            mandatoryElement={true}
                            labelName="Seleccione cantidad de cuotas mensuales a convenir (no puede exceder las 48):"
                            typeElement="select"
                            hasError={inputValidate?.empty?.qtdCuetas}
                            msgError={inputValidate?.msg?.qtdCuetas}
                            value={values.qtdCuetas}
                            listOptions={props.optionsCuetas}
                        />
                    </div>
                    
                </div>
            </CGE.PanelSection>
            <div className="row">
                <div className="col-md-12">
                    <CGE.FieldRecaptcha
                        onChange={onChangeReCaptcha}
                        sitekey={props.api_key_recaptcha}
                    />
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <CGE.Button
                    label="Enviar"
                    onClick={() => handleSubmit()}
                />
            </div>
        </CGE.Panel>
    </div>
  )
}

export default VulnerableAgreementFormEdit